/**
 *  This transform the received text by applying uppercase to its first character.
 *
 * @param {string} text - String to transform
 * @returns {string} - Received text by converting its first letter to uppercase
 */
export const capitalizeFirstLetter = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1);
